export const convertHMS = (
    value?: number | string,
    isForPlayer = false,
): string => {
    if (
        value == null ||
        (typeof value === 'number' && (Number.isNaN(value) || value < 0))
    ) {
        return '';
    }

    const sec: number =
        (typeof value === 'number' && value) ||
        (typeof value === 'string' && parseInt(value, 10)) ||
        0; // convert value to number if it's string
    const hours: number = Math.floor(sec / 3600); // get hours
    const minutes: number = Math.floor((sec - hours * 3600) / 60); // get minutes
    const seconds: number = Math.floor(sec - hours * 3600 - minutes * 60); //  get seconds
    const result: string[] = [];

    // add 0 if value < 10
    if (hours < 10) {
        if (hours !== 0) {
            result.push(isForPlayer ? `${hours}:` : `${hours}h`);
        } else {
            result.push('');
        }
    }
    if (minutes < 10) {
        if (minutes !== 0) {
            result.push(isForPlayer ? `0${minutes}:` : ` 0${minutes}min`);
        } else {
            result.push(isForPlayer ? `00:` : ``);
        }
    } else {
        result.push(isForPlayer ? `${minutes}:` : ` ${minutes}min`);
    }
    if (seconds < 10) {
        if (seconds !== 0) {
            result.push(isForPlayer ? `0${seconds}` : ` 0${seconds}sec`);
        } else {
            result.push(isForPlayer ? `00` : ``);
        }
    } else {
        result.push(isForPlayer ? `${seconds}` : ` ${seconds}sec`);
    }
    return result.join('');
};
